import { render, staticRenderFns } from "./keysComponent.vue?vue&type=template&id=cb474fe6&scoped=true"
import script from "./keysComponent.vue?vue&type=script&lang=js"
export * from "./keysComponent.vue?vue&type=script&lang=js"
import style0 from "./keysComponent.vue?vue&type=style&index=0&id=cb474fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb474fe6",
  null
  
)

export default component.exports